/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ApiResponseTripTagInfoResponse } from '../models/ApiResponseTripTagInfoResponse';
import type { ApiResponseTripTagListResponse } from '../models/ApiResponseTripTagListResponse';
import type { ApiResponseVoid } from '../models/ApiResponseVoid';
import type { CreateTagRequest } from '../models/CreateTagRequest';
import type { UpdateTagRequest } from '../models/UpdateTagRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class TripTagsService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * 태그 목록 조회
   * 비즈니스 태그 + 사용자 커스텀 태그를 조회합니다.
   * @returns ApiResponseTripTagListResponse OK
   * @throws ApiError
   */
  public getAllTags(): CancelablePromise<ApiResponseTripTagListResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/trip-tags',
    });
  }
  /**
   * 커스텀 태그 생성
   * 새로운 커스텀 태그를 생성합니다.
   * @returns ApiResponseTripTagInfoResponse OK
   * @throws ApiError
   */
  public createTag({
    requestBody,
  }: {
    requestBody: CreateTagRequest,
  }): CancelablePromise<ApiResponseTripTagInfoResponse> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/trip-tags',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * 커스텀 태그 삭제
   * 커스텀 태그를 삭제합니다. 비즈니스 태그는 삭제할 수 없습니다.
   * @returns ApiResponseVoid OK
   * @throws ApiError
   */
  public deleteTag({
    tagId,
  }: {
    tagId: string,
  }): CancelablePromise<ApiResponseVoid> {
    return this.httpRequest.request({
      method: 'DELETE',
      url: '/trip-tags/{tagId}',
      path: {
        'tagId': tagId,
      },
    });
  }
  /**
   * 커스텀 태그 수정
   * 커스텀 태그 이름을 변경합니다. 비즈니스 태그는 변경할 수 없습니다.
   * @returns ApiResponseTripTagInfoResponse OK
   * @throws ApiError
   */
  public updateTag({
    tagId,
    requestBody,
  }: {
    tagId: string,
    requestBody: UpdateTagRequest,
  }): CancelablePromise<ApiResponseTripTagInfoResponse> {
    return this.httpRequest.request({
      method: 'PUT',
      url: '/trip-tags/{tagId}',
      path: {
        'tagId': tagId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * 트립에 태그 추가
   * 특정 트립에 태그를 하나 추가합니다.
   * @returns ApiResponseVoid OK
   * @throws ApiError
   */
  public addTagToTrip({
    vin,
    tripId,
    tagId,
  }: {
    vin: string,
    tripId: string,
    tagId: string,
  }): CancelablePromise<ApiResponseVoid> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/trip-tags/vehicle/{vin}/trip/{tripId}',
      path: {
        'vin': vin,
        'tripId': tripId,
      },
      query: {
        'tagId': tagId,
      },
    });
  }
  /**
   * 트립에서 태그 제거
   * 특정 트립에서 태그를 제거합니다.
   * @returns ApiResponseVoid OK
   * @throws ApiError
   */
  public removeTagFromTrip({
    vin,
    tripId,
    tagId,
  }: {
    vin: string,
    tripId: string,
    tagId: string,
  }): CancelablePromise<ApiResponseVoid> {
    return this.httpRequest.request({
      method: 'DELETE',
      url: '/trip-tags/vehicle/{vin}/trips/{tripId}/tag/{tagId}',
      path: {
        'vin': vin,
        'tripId': tripId,
        'tagId': tagId,
      },
    });
  }
}
